'use client';

import Image from 'next/image';

import { Button, tw } from '@repo/ui';
import { getImageUrl } from '@repo/utils';

import { useClaim } from '@claim/hooks/use-claim';

export const RegisterSuccess: React.FC = () => {
  const { setIsClaiming, setSuccess, success } = useClaim();

  const handleReset = () => {
    if (!success) return;
    setSuccess(false);
    setIsClaiming(false);
  };

  return (
    <>
      <div className='relative w-[410px] max-w-[100vw]'>
        <Image
          src={getImageUrl('/claim/images/floating-dood.png')}
          alt='success'
          width={410}
          height={420}
          layout='responsive'
        />
      </div>

      <div
        className={tw(
          'z-10 -mt-[6rem] flex flex-col items-center justify-center gap-5 text-center',
        )}
      >
        <div className='z-10 mb-11 flex flex-col items-center justify-center px-2 md:px-4'>
          <p className='text-xl font-semibold text-white md:text-3xl'>
            SUCCESS! YOU'RE REGISTERED.
          </p>
          <p className='text-sm font-thin italic text-white/50 md:text-base'>
            You're ready for the $DOOD airdrop! Your final allocation will
            change if your wallet contents change prior to TGE. Return to
            dood.doodles.app anytime before the airdrop to check your status.
          </p>

          <div className='mt-4 flex w-3/4 gap-2'>
            <Button
              as='a'
              target='_blank'
              href='https://dreamnet.doodles.app/'
              theme='claim'
              size='large'
              extraClasses={'w-full'}
            >
              READ THE WHITEPAPER
            </Button>
          </div>
        </div>

        <div className='flex w-full justify-center rounded-b-[18px] bg-[#171717] px-4 py-5'>
          <Image
            priority
            src={getImageUrl('/stoodio/logos/logo_white_tight.svg')}
            alt='Doodles'
            sizes='(max-width: 640px) 85px, 107px'
            quality={100}
            width={142}
            height={42}
            className='h-[42px] w-[142px]'
          />
        </div>
      </div>
    </>
  );
};
